import { createRootRoute, Outlet, redirect, useRouterState } from "@tanstack/react-router";
import { useSistemaStore } from "features/sistema/store";
import NProgress from "nprogress";
import { Error404 } from "router/Error404";
import { Splash } from "router/Splash";
import { goToLogin } from "router/util";

let previousPath = "";

export const Route = createRootRoute({
	beforeLoad: ({ location }) => {
		// Rota pública, não fazer nada
		if (location.pathname.startsWith("/p/")) {
			return;
		}

		// Link antigo da documentação da API: agora é pública, sem exigir login
		if (location.pathname.startsWith("/a/api-docs")) {
			throw redirect({ to: "/p/api-docs" });
		}

		if (goToLogin()) {
			throw redirect({ to: "/auth/login" });
		}

		if (location.pathname === "/") {
			throw redirect({ to: "/a/painel-gerencial" });
		}
	},
	component: () => {
		const { location } = useRouterState();
		const splash = useSistemaStore((s) => s.splash);

		if (location.pathname !== previousPath) {
			window.scrollTo(0, 0);
			NProgress.start();
		}

		setTimeout((): void => {
			NProgress.done();
			previousPath = location.pathname;
		}, 300);

		if (splash) {
			return <Splash />;
		}

		return <Outlet />;
	},
	notFoundComponent: () => <Error404 />,
});
